import React from "react";

import { Button } from "@packages/ds";
import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  body, html {
    padding: 0;
    margin: 0;
  }
`;

export const Layout = styled.div`
  height: 100vh;
  width: 100%;
  overflow: auto;
  box-sizing: border-box;
  padding: 80px 32px 32px 32px;

  display: flex;
  align-items: center;
  flex-direction: column;
  background: var(
    --gradient-CallToAction-Light,
    linear-gradient(
      182deg,
      #f7f8f8 3%,
      #fff 113.2%,
      rgba(255, 255, 255, 0.02) 169.42%
    ),
    linear-gradient(
      260deg,
      #f5fec6 0%,
      #ffece6 33.56%,
      #ffe7ff 75.58%,
      #e0daff 100%
    ),
    linear-gradient(180deg, #181c1e 0%, #181c1e 100%)
  );
  background: var(
    --gradient-CallToAction-Light,
    linear-gradient(
      182deg,
      color(display-p3 0.9686 0.9725 0.9725) 3%,
      color(display-p3 1 1 1 / 0) 113.2%,
      color(display-p3 1 1 1 / 0.02) 169.42%
    ),
    linear-gradient(
      260deg,
      color(display-p3 0.9686 0.9961 0.8) 0%,
      color(display-p3 1 0.9294 0.9059) 33.56%,
      color(display-p3 0.9922 0.9098 0.9922) 75.58%,
      color(display-p3 0.8745 0.8549 1) 100%
    ),
    linear-gradient(
      180deg,
      color(display-p3 0.098 0.1098 0.1176 / 0) 0%,
      color(display-p3 0.098 0.1098 0.1176) 100%
    )
  );
`;

export const Title = styled.h1`
  color: var(--mode-text-neutral-default, #141e21);

  /* headings/type-H1 */
  font-family: var(--ff-sans, "Open Sans");
  font-size: var(--fs-xxxl, 32px);
  font-style: normal;
  font-weight: 700;
  margin: 0;
`;

export const TitleUpsun = styled.span`
  color: color(display-p3 0.3765 0.275 1);
`;

export const FirstParagraph = styled.p`
  margin: 16px 0 0 0;
  max-width: 518px;
  color: var(--mode-text-neutral-default-weak, #344d54);
  color: var(
    --mode-text-neutral-default-weak,
    color(display-p3 0.2392 0.2941 0.3216)
  );
  text-align: center;

  /* general/type-body */
  font-family: var(--ff-sans, "Open Sans");
  font-size: var(--fs-m, 15px);
  font-style: normal;
  font-weight: 400;
`;

export const H2 = styled.h2`
  color: var(--mode-text-neutral-default, #141e21);
  color: var(
    --mode-text-neutral-default,
    color(display-p3 0.0941 0.1176 0.1294)
  );
  text-align: center;
  margin: 0;

  /* headings/type-H3 */
  font-family: var(--ff-sans, "Open Sans");
  font-size: var(--fs-xl, 18px);
  font-style: normal;
  font-weight: 700;
`;

export const SecondParagraph = styled(FirstParagraph)`
  max-width: 619px;
  margin-top: 16px;
  margin-bottom: 24px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Ticks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  margin-bottom: 32px;
`;

export const TickContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: var(--mode-text-neutral-default-weak, #344d54);

  /* general/type-body-semibold */
  font-family: var(--ff-sans, "Open Sans");
  font-size: var(--fs-m, 15px);
  font-style: normal;
  font-weight: 600;
`;

export const Tick = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10 17.0999C9.70005 17.0999 9.50005 16.9999 9.30005 16.7999L5.10005 12.5999C4.70005 12.1999 4.70005 11.5999 5.10005 11.1999C5.50005 10.7999 6.10005 10.7999 6.50005 11.1999L10 14.6999L17.5 7.1999C17.9 6.7999 18.5 6.7999 18.9 7.1999C19.3 7.5999 19.3 8.1999 18.9 8.5999L10.7 16.7999C10.5 16.9999 10.3 17.0999 10 17.0999Z"
      fill="#6046FF"
      style={{ fill: "#6046FF", fillOpacity: 1 }}
    />
  </svg>
);

export const Frame = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    style={{ margin: "24px" }}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16 18C16.5304 18 17.0391 18.2107 17.4142 18.5858C17.7893 18.9609 18 19.4696 18 20C18 19.4696 18.2107 18.9609 18.5858 18.5858C18.9609 18.2107 19.4696 18 20 18C19.4696 18 18.9609 17.7893 18.5858 17.4142C18.2107 17.0391 18 16.5304 18 16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18ZM16 6C16.5304 6 17.0391 6.21071 17.4142 6.58579C17.7893 6.96086 18 7.46957 18 8C18 7.46957 18.2107 6.96086 18.5858 6.58579C18.9609 6.21071 19.4696 6 20 6C19.4696 6 18.9609 5.78929 18.5858 5.41421C18.2107 5.03914 18 4.53043 18 4C18 4.53043 17.7893 5.03914 17.4142 5.41421C17.0391 5.78929 16.5304 6 16 6ZM9 18C9 16.4087 9.63214 14.8826 10.7574 13.7574C11.8826 12.6321 13.4087 12 15 12C13.4087 12 11.8826 11.3679 10.7574 10.2426C9.63214 9.11742 9 7.5913 9 6C9 7.5913 8.36786 9.11742 7.24264 10.2426C6.11742 11.3679 4.5913 12 3 12C4.5913 12 6.11742 12.6321 7.24264 13.7574C8.36786 14.8826 9 16.4087 9 18Z"
      stroke="#3D4B52"
      style={{ stroke: "#3D4B52", strokeOpacity: 1 }}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UpsunButton = styled(Button)`
  border-radius: 32px;
  background: #6b43ff;
  :hover {
    background: #6b43ff;
  }
`;

export const LoginParagraph = styled.div`
  color: var(--mode-text-neutral-default, #141e21);
  color: var(
    --mode-text-neutral-default,
    color(display-p3 0.0941 0.1176 0.1294)
  );
  text-align: center;
  margin-bottom: 24px;

  /* general/type-body-bold */
  font-family: var(--ff-sans, "Open Sans");
  font-size: var(--fs-m, 15px);
  font-style: normal;
  font-weight: 700;
`;

export const AnimatedLogo = styled.img`
  height: 124px;
  width: 124px;
  margin-bottom: 24px;
`;
